import { useCartContext } from "../context";
import { useEffect } from "react";
import { useAuthContext } from "../authContext";
import './addToCart.css'
import { useState } from "react";
import MessageContainer from "../messageContainer/MessageContainer";
import { noAuthentication } from "../data/data";


const AddToCart = ({ product }) => {
   const { cart, addToCart, removeFromCart } = useCartContext();
  //const cart = useSelector((state) => state.cart);
//   const dispatch = useDispatch();

const [showLoginPopup,setshowLoginPopup] = useState(false);

const{userExists} = useAuthContext();

  const productInCart = cart[product.id];

  useEffect(() => {
    const timeoutIdNoLogin = setTimeout(() => {
      setshowLoginPopup(false);
    }, 5000);
    return () => clearTimeout(timeoutIdNoLogin);
  }, [showLoginPopup]);


  const handleAdd = () => {
    if(userExists) addToCart(product);
    else setshowLoginPopup(true);
    // dispatch(addToCart(product));
  };
  const handleRemove = () => {
    removeFromCart(product);
    // dispatch(removeFromCart(product));
  };

  if (!productInCart) {
    return (
      <div>
        <button className="add-to-cart" onClick={handleAdd}>
          Add to Cart
        </button>
        {showLoginPopup?<MessageContainer data={noAuthentication} />:null}
      </div>
    );
  } else {
    return (
      <div className="add-to-cart-container">
        <div onClick={handleRemove} className="add">
          -
        </div>
        {productInCart.quantity}
        <div className="add" onClick={handleAdd}>
          +
        </div>
      </div>
    );
  }
};

export default AddToCart;